import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import UnauthorizedAccess from "../components/UnauthorizedAccess/UnauthorizedAccess";
import { CONTACT_URL, REQUIRED_GROUP_ID } from "../utils/constants"; // Ensure this constant is defined in your constants file

// ...existing imports...

const AuthWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  // Authorization check
  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      const account = accounts[0];
      const idTokenClaims = account?.idTokenClaims;
      const userGroups = idTokenClaims?.groups || {};
      const authorized = Object.values(userGroups).includes(REQUIRED_GROUP_ID);
      setIsAuthorized(authorized);
      setIsLoading(false);
    }
  }, [accounts, inProgress]);

  // Login redirect effect
  useEffect(() => {
    if (accounts.length === 0 && inProgress === InteractionStatus.None) {
      instance.loginRedirect();
    }
  }, [accounts, inProgress, instance]);

  const handleRetry = () => {
    if (inProgress === InteractionStatus.None) {
      instance.loginRedirect();
    }
  };

  const handleContactSupport = () => {
    window.open(CONTACT_URL, "_blank");
  };

  if (
    isLoading ||
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Login
  ) {
    return <div>Loading...</div>;
  }

  if (accounts.length === 0) {
    // Don't render anything while redirecting
    return null;
  }

  if (!isAuthorized) {
    return (
      <UnauthorizedAccess
        onRetry={handleRetry}
        onContactSupport={handleContactSupport}
      />
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
